module.exports = __webpack_public_path__ + "static/img/Msk.bcdf113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Msk.jpg
// module id = 2kXX
// module chunks = 1